import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GenericModal } from "@Shared/components/modals";
import MaterialInput from "@Shared/components/inputs/material-input";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import Colorpicker from "@Shared/components/inputs/colorpicker";
import DocumentTagsTable from "@Broker/@Modules/clients/applications/documents/components/documents-page/document-classification/document-listing/document-tags-table.vue";
import { CREATE_DOCUMENT_LABEL, REMOVE_DOCUMENT_LABEL, EDIT_DOCUMENT_LABEL } from "@Broker/@Modules/clients/applications/documents/store/documents-actions";
import { SET_DOCUMENT_LABEL } from "@Broker/@Modules/clients/applications/documents/store/documents-mutations";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { USER_DOCUMENT_LABELS, BROKERAGE_DOCUMENT_LABELS } from "@Broker/@Modules/clients/applications/documents/store/documents-getters";
import { cloneDeep } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ManageDocumentTagsModal",
  components: {
    GenericModal,
    MaterialInput,
    SimpleButton,
    Colorpicker,
    DocumentTagsTable
  },
  mixins: [validationMixin],
  validations: {
    newLabel: {
      name: {
        required
      },
      colour: {
        required
      }
    }
  },
  props: {
    labelName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      modalOpened: false,
      creating: false,
      creatingSucceeded: true,
      newLabel: {
        name: "",
        colour: "#FFFFFF",
        shared: false
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("DocumentsStore", [USER_DOCUMENT_LABELS, BROKERAGE_DOCUMENT_LABELS])), {}, {
    options() {
      return {
        filterable: false,
        showChildRowToggler: false,
        headings: {
          name: "name",
          colour: "colour",
          preview: "preview",
          delete: ""
        },
        tabbable: false,
        columnsClasses: {
          colour: "w-30 w-md-20",
          preview: "w-20",
          name: "w-50"
        },
        skin: "table table-hover",
        perPage: 99999
      };
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("DocumentsStore", [CREATE_DOCUMENT_LABEL, EDIT_DOCUMENT_LABEL, REMOVE_DOCUMENT_LABEL])), mapMutations("DocumentsStore", [SET_DOCUMENT_LABEL])), {}, {
    async handleCreateTag() {
      if (this.$v.$invalid) return;
      this.creating = true;
      try {
        await this.CREATE_DOCUMENT_LABEL({
          label: cloneDeep(this.newLabel)
        });
        this.cleanValues();
        this.creatingSucceeded = true;
      } catch (error) {
        this.creatingSucceeded = false;
      } finally {
        this.creating = false;
      }
    },
    preEditLabel(label, isShared = true) {
      this.SET_DOCUMENT_LABEL({
        label,
        isShared
      });
    },
    async editLabel(label, isShared) {
      const tableRef = isShared ? "brokerageLabelsTable" : "userLabelsTable";
      const {
        succeeded
      } = await this.EDIT_DOCUMENT_LABEL({
        label,
        isShared
      });
      this.$refs[tableRef].finishEditing({
        succeeded,
        id: label.id
      });
      if (succeeded) this.refreshDocuments();
    },
    async deleteBrokerLabel(id) {
      try {
        await this.REMOVE_DOCUMENT_LABEL({
          labelId: id,
          isShared: true
        });
        this.refreshDocuments();
      } catch (error) {
        this.$set(this.$refs.brokerageLabelsTable.deleting[id], "loading", false);
      }
    },
    async deleteUserLabel(id) {
      try {
        await this.REMOVE_DOCUMENT_LABEL({
          labelId: id,
          isShared: false
        });
        this.refreshDocuments();
      } catch (error) {
        this.$set(this.$refs.userLabelsTable.deleting[id], "loading", false);
      }
    },
    cleanValues() {
      this.newLabel.name = "";
      this.newLabel.colour = "#FFFFFF";
      this.newLabel.shared = false;
    },
    initValues() {
      this.newLabel.name = this.labelName;
    },
    refreshDocuments() {
      this.$emit("refreshDocuments");
    }
  })
});